import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Requests.css";
import Pagination from "../../components/Pagination/Pagination";
import PopUp from "../../components/PopUp/PopUp";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
//import { Globals } from "../../global/Globals";
import Search from "../../components/SearchBar/Search";
import Table from "../../components/Table/Table";
import Toast from "../../components/Toast/Toast";
import { getBriefRequests, getBriefShelve, getUserApproval, getProposalReAssign, briefStatusUpdate, proposalStatusUpdate, briefShelveStatusUpdate, userProposalUpdate } from "../../services/api";
import Loader from "../../components/Loader/Loader";
import NoResultsComponent from './../../components/NoResults/NoResult';
import { useCluster } from "../../pages/ClusterContext/ClusterContext";
import { fetchFilterByProducerBy,fetchFilterByCreatedBy } from './../../services/dashboardAPI';
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from "../../context/Languagecontext";
import FallBackLabel from '../../global/Globals_Eng.json';
import { Globals as OldGlobals } from "../../global/Globals";

const intiActiveDropdown = {
  activeDropdown: null,
  dropdowns: {
    CREATEDBY: { options: [], selected: [], selectedText: [], isloading: false },
    REQUESTEDBY: { options: [], selected: [], selectedText: [], isloading: false },
  },
}

let dataRender;
let paginationPageChange = () => { };
const Requests = () => {
    const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const { selectedClusters } = useCluster();
  const apiProgress = useRef(false); // To prevent the API call from being made multiple times while page mounts

  const [requestData, setRequestData] = useState(null);
  const [propsalsCount, setProposalsCount] = useState(null);
  const [requestDataStatus, setRequestDataStatus] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [activeTab, setActiveTab] = useState(FallBackLabel.REQUEST.BRIEF_RE_ASSIGN);
  const [popup, setPopup] = useState({ open: false });
  const [toast, setToast] = useState({ open: false, status: '', title: "" });
  const [dataSorting, setDataSorting] = useState(1)
  const [clusterId, setClusterId] = useState();
  const [clusterName, setClusterName] = useState();
  const [dropdownState, setDropdownState] = useState(intiActiveDropdown);

  const [requetedBy, setRequestedBy] = useState("")
  const [createdBy, setCreatedBy] = useState("")


  const dropdownRefs = useRef({}); // Store refs for dropdowns

  const handlePopupClose = () => {
    setSelectedItem(null);
  };

  const cardsPerPage = Globals.MAX_COUNT.REQUEST_TAB_COUNT;
  const onPageChange = (pageNumber, setPage = () => { }) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  const openPopup = (data) => {
    setPopup(data)
  }
  const closePopup = () => {
    setPopup({ open: false })
  }

  async function fetchAllProposals(body, dataUpdation = true) {
    try {
      let responseData;
      if (dataUpdation !== "sorting" && dataUpdation !== false) {
        setRequestData(null);
      }  // To avoid flickering while switching between tabs and dataUpdation -> to prevent the data from being updated while of the changing of page
      switch (activeTab) {
        case FallBackLabel.REQUEST.BRIEF_RE_ASSIGN:
          setRequestDataStatus(null);
          responseData = await getBriefRequests(body);
          setRequestData(responseData.data.content.simplifiedBriefRequests);
          setProposalsCount(responseData?.data?.content?.pageCount)
          setRequestDataStatus(responseData.data.status);
          break;
        case FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN:
          setRequestDataStatus(null);
          responseData = await getProposalReAssign(body);
          setRequestData(responseData.data.content.simplifiedBriefRequests);
          setProposalsCount(responseData?.data?.content?.pageCount)
          setRequestDataStatus(responseData.data.status);
          break;
        case FallBackLabel.REQUEST.BRIEF_SHELVE:
          setRequestDataStatus(null);
          responseData = await getBriefShelve(body);
          setRequestData(responseData.data.content.simplifiedBriefRequests);
          setProposalsCount(responseData?.data?.content?.pageCount)
          setRequestDataStatus(responseData.data.status);
          break;
        case FallBackLabel.REQUEST.USER_APPROVAL:
          setRequestDataStatus(null);
          responseData = await getUserApproval(body);
          setRequestData(responseData.data.content.simplifiedBriefRequests);
          setProposalsCount(responseData?.data?.content?.pageCount)
          setRequestDataStatus(responseData.data.status);
          break;
        default:
          throw new Error("Invalid activeTab");
      }
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  }

  useEffect(() => {
    const initialCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (initialCluster?.length > 0) {
      setClusterId(initialCluster[0].clusterId);
      setClusterName(initialCluster[0].clusterName);
    }
  }, [selectedClusters])



  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some(
      (ref) => ref?.contains(event.target)
    );

    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const RenderPopup = () => {
    if (selectedItem && selectedItem.status) {
      let extraprops = {};
      if (
        selectedItem.status === "Drafts" ||
        selectedItem.status === "Approved" ||
        selectedItem.status === "Rejected"
      ) {
        extraprops.normalActionText = "Submit";
        extraprops.normalAction = () => { };
      }
      return (
        <PopUp
          title="Proposal Details"
          text={"Your proposal status is : " + selectedItem.status}
          onClose={() => handlePopupClose()}
          {...extraprops}
        />
      );
    } else {
      return null;
    }
  };

  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    paginationPageChange(1);

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName]?.options.length === 0
    ) {
      await fetchOptions(dropdownName);
    }
  };

  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      let response;
      let filterData = '';
      if (dropdownName === FallBackLabel.FETCH_CREATEDBY || dropdownName === FallBackLabel.FETCH_REQUESTEDBY) {
        response = activeTab === FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN && dropdownName === FallBackLabel.FETCH_CREATEDBY  ? await fetchFilterByProducerBy(OldGlobals.USER_ROLES.PRODUCER, clusterId): await fetchFilterByCreatedBy(OldGlobals.USER_ROLES.SNR_MGR, clusterId);
        filterData = response.data.content;
      }
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    setRequestDataStatus(null);
    const selectedArray = selectAll ? options.map((option) => String(option.id)) : [];
    const selectedValues = selectedArray.join(",");
    const selectedDataText = options.map((option) => String(option.name));

    if (dropdownName === "CREATEDBY") {
      setCreatedBy(selectedValues);
    } else if (dropdownName === "REQUESTEDBY") {
      setRequestedBy(selectedValues);
    }

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectedArray,
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const handleSelect = (dropdownName, value) => {

    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;

      const selectedArray = dropdown.selected || [];
      const isSelected = selectedArray.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? selectedArray.filter((item) => item !== String(value.id))
        : [...selectedArray, String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
          ...dropdown.selectedText.filter((item) => item !== String(value.name)),
          String(value.name),
        ];

      // Convert the selected values into a comma-separated string
      const selectedValues = newSelected.join(",");
      if (dropdownName === "CREATEDBY") {
        setCreatedBy(selectedValues);
      } else if (dropdownName === "REQUESTEDBY") {
        setRequestedBy(selectedValues);
      }
      // Clear ALL button logic
      setEnableClearAll(true)

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };


  const handleClearAll = () => {
    if (enableClearAll) {
      setCurrentPage(1);
      setRequestDataStatus(null);
      setEnableClearAll(false);
      setSearchQuery(null);
      paginationPageChange(1);
      setRequestedBy("");
      setCreatedBy("");
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }
  };


  const handleSorting = (sorting) => {
    setRequestDataStatus(null);
    setDataSorting(sorting);
  }

  const handleSearch = (term) => {
    setRequestDataStatus(null);
    setSearchQuery(term);
    setEnableClearAll(term !== "");
    paginationPageChange(1);
  };

  const proposalData = (dataUpdation) => {
    //payload data
    const MyProposalsdata = {
      take: cardsPerPage,
      skip: currentPage,
      search: searchQuery ? searchQuery : '',
      filter: dataSorting,
      createdBy: createdBy,
      requestedBy: requetedBy,
      clusterId: clusterId
    };
    clusterId && fetchAllProposals(MyProposalsdata, dataUpdation);
  }

  useEffect(() => { 
    setCurrentPage(1);
    setDataSorting(1);
    paginationPageChange(1);
    proposalData();
    setRequestedBy("");
      setCreatedBy("");
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          return acc;
        }, {});
        console.log("prev",clearedDropdowns)
        return { ...prev, dropdowns: clearedDropdowns };
      });
  }, [activeTab])


  useEffect(() => {

    proposalData();
  }, [searchQuery,clusterId])

  useEffect(() => {
    proposalData("sorting");
  }, [dataSorting])

  // To call the API only when the page is changed, on initial load api should be not called
  useEffect(() => {
    if (apiProgress.current) { proposalData(false) }
    else {
      apiProgress.current = true;
    }
  }, [currentPage,createdBy, requetedBy])

  const popupApiHandler = (body) => {
    switch (activeTab) {
      case FallBackLabel.REQUEST.BRIEF_RE_ASSIGN:
        return briefStatusUpdate(body)
      case FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN:
        return proposalStatusUpdate(body)
      case FallBackLabel.REQUEST.BRIEF_SHELVE:
        return briefShelveStatusUpdate(body)
      case FallBackLabel.REQUEST.USER_APPROVAL:
        return userProposalUpdate(body)

      default:
        throw new Error("");
    }
  }

  const briefStatusUpdateApi = () => {
    popupApiHandler(popup.body)
      .then((response) => {
        if (response.data.status === "OK") {
          renderToast("success", popup.toastMessage)
          proposalData()
        } else {
          renderToast("error", Globals.TOAST_FAILURE);
        }
      })
      .catch((error) => {
        renderToast("error", Globals.TOAST_FAILURE)
        proposalData()
        console.error(error);
      });
  }


  const renderToast = (status, title) => {
    setToast({ open: true, status: status, title: title });
    setTimeout(() => {
      setToast({ open: false, status: '', title: '' });
    }, 4000);
  }

  const UpdateTab = (tab) => {
    setDropdownState(intiActiveDropdown);
    setActiveTab(tab);
  }

  //language change logic
    useEffect(() => {
    setCurrentPage(1);
      setRequestDataStatus(null);
      setEnableClearAll(false);
      setSearchQuery(null);
      paginationPageChange(1);
      setRequestedBy("");
      setCreatedBy("");
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options:[] };
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
    }, [languages]);

  return (
    <>
      <div className="request-My_Proposals">
        <div className="dashboard-top">
          <div className="dashboard-heading">{Globals.REQUEST.REQUESTS}</div>
        </div>
        <div className="request-content-box">
          <div className="request-all-proposal-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`proposal-overview-tab ${activeTab === FallBackLabel.REQUEST.BRIEF_RE_ASSIGN ? "active" : ""
                  }`}
                onClick={() => UpdateTab(FallBackLabel.REQUEST.BRIEF_RE_ASSIGN)}
              >
                {Globals.REQUEST.BRIEF_RE_ASSIGN}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN
                  ? "active"
                  : ""
                  }`}
                onClick={() => UpdateTab(FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN)}
              >
                {Globals.REQUEST.PROPOSAL_RE_ASSIGN}
              </div>

              <div
                className={`proposal-overview-tab ${activeTab === FallBackLabel.REQUEST.BRIEF_SHELVE ? "active" : ""
                  }`}
                onClick={() => UpdateTab(FallBackLabel.REQUEST.BRIEF_SHELVE)}
              >
                {Globals.REQUEST.BRIEF_SHELVE}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === FallBackLabel.REQUEST.USER_APPROVAL ? "active" : ""
                  }`}
                onClick={() => UpdateTab(FallBackLabel.REQUEST.USER_APPROVAL)}
              >
                {Globals.REQUEST.USER_APPROVAL}
              </div>
            </div>
          </div>
          <div className="request-all-proposal-top-seperater"></div>
          {activeTab !== FallBackLabel.REQUEST.USER_APPROVAL ? (
            <div className="filters">
              <div className="results">
                {propsalsCount} {Globals.REQUEST.RESULTS}
              </div>
              <div className="row_spearator"></div>
              <div className="filterHeading">{Globals.PRODUCER.FILTERBY}  </div>
              <CheckboxDropDown
                isOpen={activeDropdown === "CREATEDBY"}
                options={dropdownState.dropdowns.CREATEDBY.options}
                onToggle={() => handletog("CREATEDBY")}
                onSelectAll={(selectAll, options) => handleSelectAll("CREATEDBY", selectAll, options)}
                onSelect={(value) => handleSelect("CREATEDBY", value)}
                title={activeTab === FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN?Globals.FILTER.PRODUCER  :Globals.FILTER.CREATEDBY}
                isCreatedBy={true}
                selectedValues={dropdownState.dropdowns.CREATEDBY.selected}
                dropdownRef={(el) => (dropdownRefs.current["CreatedBy"] = el)}
                selectedItems={dropdownState.dropdowns.CREATEDBY.selectedText}
              />
              <CheckboxDropDown
                isOpen={activeDropdown === "REQUESTEDBY"}
                options={dropdownState.dropdowns.REQUESTEDBY.options}
                onToggle={() => handletog("REQUESTEDBY")}
                onSelectAll={(selectAll, options) => handleSelectAll("REQUESTEDBY", selectAll, options)}
                onSelect={(value) => handleSelect("REQUESTEDBY", value)}
                title={Globals.FILTER.REQUESTEDBY}
                isCreatedBy={true}
                selectedValues={dropdownState.dropdowns.REQUESTEDBY.selected}
                dropdownRef={(el) => (dropdownRefs.current["RequestedBy"] = el)}
                selectedItems={dropdownState.dropdowns.REQUESTEDBY.selectedText}
              />

              <div
                className={enableClearAll ? "clear clearAllEnable" : "clear"}
                onClick={() => handleClearAll()}
              >
              {Globals.PRODUCER.CLEARALL}
              </div>
              <div className="request-search">
                <Search
                  onSearch={handleSearch}
                  searchedFor={searchQuery}
                  placeholder={activeTab === FallBackLabel.REQUEST.PROPOSAL_RE_ASSIGN ? Globals.REQUESTSEARCH.SEARCHPROPOSALNO: Globals.REQUESTSEARCH.SEACHBREIFNO}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {requestData && requestData?.length > 0 ? (
            <div
              className={`Table_data ${activeTab === FallBackLabel.REQUEST.USER_APPROVAL ? "mt-4" : ""
                }`}
            >
              <Table
                data={requestData}
                onSort={handleSorting}
                navigate={navigate}
                form={"requests"}
                activeTab={activeTab}
                popupShow={openPopup}
                clusterName={clusterName}
                sortKey ={dataSorting}
              />
            </div>
          ) : requestDataStatus && requestDataStatus?.length > 0 ? (
            <div className="no-data">
              <NoResultsComponent
                data={{
                  message:
                    (searchQuery && searchQuery.length > 0)
                      ? Globals.NO_RESULTS_MESSAGE
                      : Globals.NO_DATA_WITHOUTFILTER,
                  img:
                    (searchQuery && searchQuery.length > 0)
                      ? OldGlobals.NO_RESULTS_IMG
                      : OldGlobals.NO_DATA_FOUND_IMG,
                  submessage:
                    (searchQuery && searchQuery.length > 0)
                      ? Globals.NO_RESULTS_SUBMESSAGE
                      : "",
                }}
              />
            </div>
          ) : (
            <Loader height={50} width={50} component={"Requests"} />
          )}
          {/*Pagination Part*/}
          <div className="request-pagination-container">
            {requestData?.length > 0 ? (
              <Pagination
                totalPages={Math.ceil(
                  propsalsCount / Globals.MAX_COUNT.REQUEST_TAB_COUNT
                )}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <RenderPopup />
      {popup.open && (
        <PopUp
          title={popup.title}
          text={popup.promptText}
          onClose={closePopup}

          {...(popup.negativeActionText && {
            negativeAction: () => {
              briefStatusUpdateApi();
              closePopup();
            },
            negativeActionText: popup.negativeActionText
          })}
          {...(popup.normalActionText && {
            normalAction: () => {
              closePopup();
              briefStatusUpdateApi();
            },
            normalActionText: popup.normalActionText,
          })}
          proposalBodyVal={popup.body}
        />
      )}
      {toast.open && (
        <Toast
          status={toast.status}
          onClose={() => {
            setToast({ open: false, status: "", title: "" });
          }}
          title={toast.title}
        />
      )}
    </>
  );
};

export default Requests;
